import { get } from 'helpers/api';
import types from './types';

// Entries
export const getEntriesIfNotLoaded = (offset, filters) => {
  return (dispatch, getState) => {
    const { isEntriesLoaded, isEntriesLoading } = getState().feed;

    // if (!isEntriesLoaded && !isEntriesLoading) {
    return dispatch(getEntries(offset, filters));
    // } else {
    //   return false;
    // }
  };
};

export const getEntries = (offset, filters) => {
  return (dispatch, getState) => {
    return get('/insight', {
      data: { offset, ...filters },
      before: () => dispatch(getEntriesStart()),
      success: entries => {
        if (offset) {
          dispatch(getEntriesSuccess(entries));
        } else {
          dispatch(getInitEntriesSuccess(entries));
        }
      },
    });
  };
};

const getEntriesStart = () => {
  return {
    type: types.GET_ENTRIES_START,
  };
};

const getEntriesSuccess = entries => {
  return {
    type: types.GET_ENTRIES_SUCCESS,
    entries,
  };
};

const getInitEntriesSuccess = entries => {
  return {
    type: types.GET_INIT_ENTRIES_SUCCESS,
    entries,
  };
};



// WEBPACK FOOTER //
// state/feed/actions.js